import { IconButton } from "@mui/material";
import { KeyConstant, SystemConstant } from "const";
import { saveMessageInQueue } from "pages/HomePage/components/MessengerChat/ConversationContext";
import { useState } from "react";
import { getInteractor } from "services/local.service";
import { StorageUtil, toCamel, uuid } from "utils";
import FullEmojiMenu from "components/FullEmojiMenu";
import EmojiMenu from "pages/HomePage/components/MessengerChat/ChatItem/EmojiMenu";

const withReaction = Icon => {
  return props => {
    const { message, IconProps, ...otherComponentProps } = props;

    const prefixKey = StorageUtil.getCurrentPrefixKey();
    const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);
    const branchId = StorageUtil.getItem(KeyConstant.KEY_BRANCH_ID, prefixKey);

    const [reactionList, setReactionList] = useState([]);
    const [emojiAnchorEl, setEmojiAnchorEl] = useState();
    const [isShowFullEmoji, setIsShowFullEmoji] = useState(false);

    const handleShowShortenEmoji = event => setEmojiAnchorEl(event.target);

    const handleShowFullEmoji = () => setIsShowFullEmoji(true);

    const handleCloseEmoji = () => {
      setEmojiAnchorEl(null);
      setIsShowFullEmoji(false);
    };

    const handleSelectEmoji = async value => {
      setEmojiAnchorEl(null);
      setIsShowFullEmoji(false);

      let newReactionList;
      let existedReaction = reactionList.filter(react => react.content === value && react.senderId === accountId);
      let currentAccountReactionIndex = reactionList.findIndex(reaction => reaction.senderId === accountId);

      let options = {};
      if (message.sendAsDirectMessage)
        options.send_as_direct_message = SystemConstant.THREAD_MSG_SEND_OPTION.sendAsDirect;

      if (existedReaction.length > 0) {
        newReactionList = reactionList.filter((react, index) => index !== currentAccountReactionIndex);
        setReactionList(newReactionList);
        await saveMessageInQueue({
          prefixKey,
          groupId: message.groupId,
          threadId: message.threadId,
          sendType: SystemConstant.SEND_TYPE.deleteReaction,
          content: value,
          parentId: message.sourceId,
          options,
        });
      } else {
        const currentAccount = toCamel(await getInteractor().LocalAccountService.get(accountId, branchId));
        const newReactionMessage = {
          id: uuid(),
          sourceId: uuid(),
          parentId: message.sourceId,
          threadId: null,
          sendType: SystemConstant.SEND_TYPE.reaction,
          accountId: accountId,
          content: value,
          mentions: null,
          senderId: accountId,
          groupId: message.groupId,
          created: Date.now(),
          accountName: currentAccount?.name || "No name",
          accountAvatarId: currentAccount?.avatarId || null,
        };

        if (currentAccountReactionIndex >= 0) {
          newReactionList = reactionList.map((react, index) =>
            index === currentAccountReactionIndex ? newReactionMessage : react,
          );
        } else {
          newReactionList = [...reactionList, newReactionMessage];
        }

        setReactionList(newReactionList);
        await saveMessageInQueue({
          prefixKey,
          groupId: message.groupId,
          threadId: message.threadId,
          sendType: SystemConstant.SEND_TYPE.reaction,
          content: value,
          parentId: message.sourceId,
          options,
        });
      }
    };

    return (
      <>
        <IconButton onClick={handleShowShortenEmoji} {...otherComponentProps}>
          <Icon {...IconProps} />
        </IconButton>

        <EmojiMenu
          open={Boolean(emojiAnchorEl) && !isShowFullEmoji}
          anchorEl={emojiAnchorEl}
          onClose={handleCloseEmoji}
          onOpenFullEmojiMenu={handleShowFullEmoji}
          onSelectEmoji={handleSelectEmoji}
        />

        <FullEmojiMenu
          open={Boolean(emojiAnchorEl) && isShowFullEmoji}
          onClose={handleCloseEmoji}
          anchorEl={emojiAnchorEl}
          onSelectEmoji={handleSelectEmoji}
        />
      </>
    );
  };
};

export default withReaction;
